import {SERVER_API_PLATFORMJK} from '../../../constans/index';
import {CREATE_FANPAGE_FUNBOT, FAILURE_CREATE_FANPAGE_FUNBOT} from '../../../types/index';
import {RSAA} from 'redux-api-middleware';
import headers from "../../../utils/headers";

const create_page_facebook_action = (data_target) => ({

    [RSAA]: {
        endpoint: `${SERVER_API_PLATFORMJK}/api/pages`,
        method: 'POST',
        headers: (headers()),
        body: (() => {
            return JSON.stringify(data_target)
        }),
        types: [
            'REQUEST_CREATE_FANPAGE_FUNBOT',
            {
                type: CREATE_FANPAGE_FUNBOT,
                payload: (action, state, res) => {
                    const contentType = res.headers.get('Content-Type');

                    if (contentType && ~contentType.indexOf('json')) {
                        return {
                            "code": 0,
                            "type": "create_page"
                        }
                    }
                },
            },
            {
                type: FAILURE_CREATE_FANPAGE_FUNBOT,
                payload: (action, state, res) => {
                    const contentType = res.headers.get('Content-Type');

                    if (contentType && ~contentType.indexOf('json')) {
                        return res.json()
                    }
                },
            },
        ]
    }

});

export {create_page_facebook_action}